let appConfig = {
	...window.appConfig,
	/* defaults */
	basePathEma: '/ema/Bamboo/Home/'
};

const appConfigService = {
	get: getConfig,
	set: setConfig
};

function getConfig(key) {
	if (!key) {
		return appConfig;
	}

	return appConfig[key];
}

function setConfig(config) {
	appConfig = {
		...appConfig,
		...config
	};
}

export default appConfigService;